import React, {FC, JSX} from 'react';
import {HeadingType} from './TextTypes';


const H1: FC<HeadingType> = ({children, ...props}): JSX.Element => <h1
    className={'text-neutral mx-auto font-[600] text-[1.25rem]'}
    {...props}
>{children}</h1>;

export default H1;